import clsx from 'clsx'
import { useEffect, useRef, useState, type PropsWithChildren } from 'react'

interface PeriodButtonProps extends PropsWithChildren {
  startDate: Date
  endDate: Date
  getDatePeriod: (startDate: Date, endDate: Date) => void
}

export const PeriodButton = ({
  children,
  startDate,
  endDate,
  getDatePeriod,
}: PeriodButtonProps) => {
  const [active, setActive] = useState<boolean>(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    function handleClickOut(event: MouseEvent) {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setActive(false)
      }
    }

    document.addEventListener('mouseup', handleClickOut)

    return () => {
      document.removeEventListener('mouseup', handleClickOut)
    }
  }, [])

  return (
    <button
      ref={buttonRef}
      onClick={() => {
        getDatePeriod(startDate, endDate)
        setActive(true)
      }}
      className={clsx(
        `cursor-pointer text-start text-nowrap text-base`,
        active && 'text-[var(--brand-blue-1)]',
      )}
    >
      {children}
    </button>
  )
}
